// TODO fachlich validieren: Eigener Strommix nutzt aktuell Schätzung 0.05 kg CO2/kWh.
export const ELECTRICITY_EMISSION_FACTORS = {
  swiss_mix: 0.128,
  renewable: 0.012,
  own_mix: 0.05,
  unknown: 0.128,
};

export const HEATING_EMISSION_FACTORS = {
  'Heizöl': 0.265,
  'Erdgas': 0.20,
  'Fernwärme': 0.10,
  'Holz/Pellets': 0.025,
  'Wärmepumpe': 0.043,
  'Solarwärme': 0.005,
  'Andere': 0.20,
  'Weiss nicht': 0.20,
};

export const LITER_TO_KWH = {
  'Heizöl': 10,
  'Erdgas': 10,
  'Fernwärme': 1,
  'Holz/Pellets': 4.8,
  'Wärmepumpe': 1,
  'Solarwärme': 1,
  'Andere': 10,
  'Weiss nicht': 10,
};



export const HEATING_PRICE_PER_KWH = {
  'Heizöl': 0.10,
  'Erdgas': 0.12,
  'Fernwärme': 0.13,
  'Holz/Pellets': 0.08,
  'Wärmepumpe': 0.25,
  'Solarwärme': 0.05,
  'Andere': 0.12,
  'Weiss nicht': 0.12,
};

export const ESTIMATED_ELECTRICITY_KWH_PER_M2 = 80;
export const ESTIMATED_HEATING_KWH_PER_M2 = 120;

export function deriveOperationType(
  spenglerarbeiten,
  lackierarbeiten,
  weitere
) {
  const bodyShare = parseFloat(spenglerarbeiten) || 0;
  const paintShare = parseFloat(lackierarbeiten) || 0;
  const otherShare = parseFloat(weitere) || 0;

  if (bodyShare >= 80) {
    return 'Carrosserie-Spenglerei';
  }

  if (paintShare >= 80) {
    return 'Fahrzeuglackiererei';
  }

  if (otherShare >= 80) {
    return 'Weitere';
  }

  return 'Mischbetrieb';
}

// TODO fachlich validieren: Materialbenchmarks stammen aus Mockup / Annahme.
export const MATERIAL_DEFAULTS = {
  'Carrosserie-Spenglerei': {
    abrasives: 31,
    filler: 25,
    adhesivesSealants: 12,
    maskingMaterial: 10,
    solventsCleaners: 10,
    screwsSmallParts: 12,
  },
  'Fahrzeuglackiererei': {
    abrasives: 28,
    filler: 17,
    adhesivesSealants: 11,
    maskingMaterial: 17,
    solventsCleaners: 21,
    screwsSmallParts: 6,
  },
  'Mischbetrieb': {
    abrasives: 26,
    filler: 21,
    adhesivesSealants: 17,
    maskingMaterial: 14,
    solventsCleaners: 14,
    screwsSmallParts: 8,
  },
};



export const MATERIAL_LABELS = {
  abrasives: 'Schleifmittel',
  filler: 'Spachtel & Füller',
  adhesivesSealants: 'Kleber & Dichtstoffe',
  maskingMaterial: 'Abdeckmaterial',
  solventsCleaners: 'Lösungsmittel / Reiniger',
  screwsSmallParts: 'Schrauben / Kleinteile',
};

export const CURRENT_YEAR = new Date().getFullYear();

export function getElectricityKwh(value, unit, totalAreaM2) {
  const v = parseFloat(value) || 0;
  if (unit === 'kwh') return v;
  if (unit === 'chf') return v / 0.25;
  if (unit === 'estimate') return (parseFloat(totalAreaM2) || 0) * ESTIMATED_ELECTRICITY_KWH_PER_M2;
  return 0;
}

export function getHeatingKwh(value, unit, heatingType, totalAreaM2) {
  const v = parseFloat(value) || 0;
  if (unit === 'kwh') return v;
  if (unit === 'liter') return v * (LITER_TO_KWH[heatingType] ?? 10);
  if (unit === 'tonnen') return v * 4800;
  if (unit === 'chf') return v / (HEATING_PRICE_PER_KWH[heatingType] ?? 0.12);
  if (unit === 'estimate') return (parseFloat(totalAreaM2) || 0) * ESTIMATED_HEATING_KWH_PER_M2;
  return 0;
}
